let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8i4Gc")).then(() => parcelRequire('ggpMi'));